
import * as dom from '../../modules/wpstg-dom-utils.js';

export default class WpstgCloneGenerateLoginLink {
  constructor(
  ) {
    this.generateLoginLink();
  }

  generateLoginLink() {
    const notyfG = new Notyf({
      duration: 4000,
      position: {
        x: 'center',
        y: 'bottom',
      },
      dismissible: true,
    });
    const $that = this;

    dom.addEvent(document.body, 'click', '.wpstg-generate-login-link', function(element) {
      // Get clone id
      const cloneID = element.getAttribute('data-clone');
      WPStaging.ajax(
          {
            action: 'wpstg_render_login_link_user_interface',
            clone: cloneID,
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
          },
          function(response) {
            dom.qs('#wpstg-workflow').innerHTML=response;
          },
          'HTML',
      );
    });
    dom.addEvent(document.body, 'click', '#wpstg-generate-login-link', function(element) {
      const html = '<p class=\'wpstg-push-confirmation-message\'> ' + element.getAttribute('data-alert-body') + '</p>';
      dom.confirmModal(element.getAttribute('data-alert-title'), html, element.getAttribute('data-confirm-btn-text'), 'wpstg-confirm-link-save').then(function(result) {
        if (result.value) {
          const idPrefix = '#wpstg-generate-login-link-';
          const cloneID = dom.qs(idPrefix + 'clone-id').value;
          const role = dom.qs(idPrefix + 'role').value;
          const minutes = dom.qs(idPrefix + 'minutes').value;
          const hours = dom.qs(idPrefix + 'hours').value;
          const days = dom.qs(idPrefix + 'days').value;
          const url = dom.qs(idPrefix + 'generated').getAttribute('data-url');
          const uniqueid = Date.now().toString();
          WPStaging.ajax({
            action: 'wpstg_save_generated_link_data',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            cloneID,
            role,
            minutes,
            hours,
            days,
            uniqueid,
          }, function(response) {
            if (response.success) {
              dom.qs('#wpstg-generate-login-link-head').style.display = '';
              dom.qs('#wpstg-generate-login-link-generated').innerText=url + uniqueid;
              notyfG.success(response.data.message);
            } else {
              notyfG.error(response.data.message);
            }
            return;
          }, 'json');
        }
      });
    });
    dom.addEvent(document.body, 'mouseover', '#wpstg-generate-login-link-generated', function(e) {
      dom.qs('#wpstg-generate-login-link-copy-text').innerText=dom.qs('#wpstg-generate-login-link-copy-text').getAttribute('data-copy');
      dom.qs('#wpstg-generate-login-link-copy-text').style.display = '';
    });
    dom.addEvent(document.body, 'mouseleave', '#wpstg-generate-login-link-generated', function(e) {
      dom.qs('#wpstg-generate-login-link-copy-text').style.display = 'none';
    });
    dom.addEvent(document.body, 'click', '#wpstg-generate-login-link-generated', function(element) {
      navigator.clipboard.writeText(element.innerHTML);
      dom.qs('#wpstg-generate-login-link-copy-text').innerText=dom.qs('#wpstg-generate-login-link-copy-text').getAttribute('data-copied');
    });
  };
}
